import { createBuilderModule } from '../../../builder';
import { TwoColumnSection } from './TwoColumnSection';
import { SectionName, withTracking } from '../../../observability';
import { withChildren } from '@builder.io/react';

export default createBuilderModule(
  withChildren(
    withTracking(TwoColumnSection, {
      sectionName: SectionName.TwoColumnSection,
    }),
  ),
  {
    name: 'TwoColumnSection',
    image: 'https://static.thenounproject.com/png/2529945-200.png',
    inputs: [
      { name: 'heading', type: 'string' },
      { name: 'details', type: 'richText' },
      { name: 'href', type: 'string' },
      { name: 'linkText', type: 'string' },
      { name: 'disableSpacing', type: 'boolean' },
    ],
  },
);
